import { TFunction } from 'i18next';

import { parseJsonSafe } from './ProcessingRecordModal';

// the status pill of an agent processing record; `t` is the assistants translator with keyPrefix 'agentConfig'
export const getRecordStatusInfo = (record: any, t: TFunction) => {
    const isSucceeded = record?.stepRun?.executionStatus === 'SUCCEEDED';
    const isFailed = record?.stepRun?.executionStatus === 'FAILED';
    const isPending = ['PENDING', 'SCHEDULED', 'RUNNING'].includes(record?.stepRun?.executionStatus);

    const outputData = parseJsonSafe(record.outputData);
    const hasData = outputData && outputData?.length > 0;

    if (isSucceeded && hasData) {
        return {
            label: t('historyPage.status.completed'),
            colorClass: 'bg-surface-success-weak text-content-success-strong border-line-success-strong',
        };
    } else if (isSucceeded && !hasData) {
        return {
            label: t('historyPage.status.completedNoData'),
            colorClass: 'bg-surface-warning-weak text-content-warning-strong border-line-warning-strong',
        };
    } else if (isFailed) {
        return {
            label: t('historyPage.status.failed'),
            colorClass: 'bg-surface-danger-weak text-content-danger-strong border-line-danger-strong',
        };
    } else if (isPending) {
        return {
            label: t('historyPage.status.pending'),
            colorClass: 'bg-surface-medium text-content-strong border-line-weak',
        };
    } else {
        return {
            label: t('historyPage.status.unknown'),
            colorClass: 'bg-surface-medium text-content-medium border-line-weak',
        };
    }
};
